export default {
  title: 'Gestão de Bens',
  menu: [
    {
      id: 'bens',
      title: 'Bens',
      icon: 'clipboard-list-check',
      style: 'light',
      url: '/#/bens/lista'
    },
    {
      id: 'patios',
      title: 'Pátios',
      icon: 'map-marker-check',
      style: 'regular',
      url: '/#/patios/lista'
    },
    {
      id: 'calculo',
      title: 'Cálculo de Estadas',
      icon: 'file-chart-line',
      style: 'regular',
      url: '#'
    },
    {
      id: 'remocao',
      title: 'Remoções',
      icon: 'exchange',
      style: 'regular',
      url: '/#/remocao'
    }/*,
    {
      id: 'config',
      title: 'Configurações',
      icon: 'cog',
      style: 'light',
      url: '#'
    }*/
  ]
}
